import { render, staticRenderFns } from "./FromToBox.vue?vue&type=template&id=a5261c1e&"
import script from "./FromToBox.vue?vue&type=script&lang=js&"
export * from "./FromToBox.vue?vue&type=script&lang=js&"
import style0 from "./FromToBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports